/**
 * AUTO-GENERATED from generate-icons script 🤖 - DO NOT EDIT!
 */

import { forwardRef } from 'react'
import Icon from '../icon/icon'

const LoadingIconSvg = forwardRef((props, svgRef) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={props.width || (props.height && Math.floor(+props.height * 1)) || 24}
		height={props.height || (props.width && Math.floor(+props.width / 1)) || 24}
		viewBox="0 0 24 24"
		fontSize="medium"
		ref={svgRef}
		{...props}
	>
		<path d="M12.12 3.101a8.968 8.968 0 00-8.967 8.968h1.952a7.015 7.015 0 017.015-7.015V3.1z" fill="currentColor">
			<animateTransform
				attributeType="xml"
				attributeName="transform"
				type="rotate"
				from="0 12 12"
				to="360 12 12"
				dur="0.6s"
				repeatCount="indefinite"
			/>
		</path>
	</svg>
))
LoadingIconSvg.displayName = 'LoadingIconSvg'

const LoadingIcon = forwardRef((props, ref) => <Icon component={LoadingIconSvg} ref={ref} {...props} />)
LoadingIcon.displayName = 'LoadingIcon'

LoadingIcon.defaultProps = {
	...Icon.defaultProps,
}
LoadingIcon.propTypes = {
	...Icon.propTypes,
}

export default LoadingIcon
export { LoadingIconSvg }
